var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-file-env',{attrs:{"cancelRoute":'File envs'}})
}
var staticRenderFns = []

export { render, staticRenderFns }